import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

import Vue from 'vue';
import router from '@/router';

import '@/directives';
import '@/config/editorjs';
import '@/config/element-ui';
import '@/config/vee-validate';
import '@/config/dara-components';

import App from '@/App.vue';
import i18n from '@/plugins/i18n.plugin';

Vue.use(i18n);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
